













































































import Vue from "vue";

// Import Components
import ButtonGroup from "../../../elements/button/ButtonGroup.vue";
import Button from "../../../elements/button/Button.vue";

export default Vue.extend({
  name: "TextLayerBeside",
  props: {
    inverted: {
      type: Boolean,
      required: false,
    },
    preline: {
      type: String,
      required: false,
    },
    headline: {
      type: String,
      required: true,
    },
    heroImage: {
      type: String,
      required: true,
    },
    copy: {
      type: String,
      required: false,
    },
    button: {
      type: Object,
      required: false,
    },
    buttonPrimaryText: {
      type: String,
      required: false,
    },
    buttonPrimaryFunction: {
      type: Function,
      required: false,
    },
    buttonSecondaryText: {
      type: String,
      required: false,
    },
    buttonSecondaryFunction: {
      type: Function,
      required: false,
    },
  },
  inject: {
    components: {
      default: {
        ButtonGroup,
        Button,
      },
    },
  },
});
